import React, {FC} from "react"
import moment from "moment-timezone"

import {RedemptionReportDuration} from "@irati/types"
import Spacing from "@irati/ui/src/Spacing"
import Loading from "@irati/ui/src/Loading"
import {Col, Row} from "@irati/ui/src/ColumnRow"
import {useUserSavings} from "@irati/adminReporting/hooks"

import MySavingsWidget from "./MySavingsWidget"
import BusinessTopRedemptions from "./BusinessTopRedemptions"
import UserSavingsReport from "./UserSavingsReport"
import DealLanes from "./DealLanes"

interface Props {
  duration: RedemptionReportDuration
}

const TabContent: FC<Props> = ({duration}) => {
  const thisMonth = {
    month: moment().month() + 1,
    year: moment().year()
  }
  const month = duration === RedemptionReportDuration.Monthly ? thisMonth : undefined
  const {data, load} = useUserSavings({month, duration})

  const hasSavingsThisMonth = data?.savings?.total?.value > 0

  return (
    <Loading load={load} initLoad>
      <MySavingsWidget data={data} />

      {hasSavingsThisMonth && (
        <Row marginTop={2}>
          <Col md={6}>
            <UserSavingsReport data={data?.report?.perks} />
          </Col>
          <Col md={6}>
            <BusinessTopRedemptions duration={duration} month={thisMonth} />
          </Col>
        </Row>
      )}

      {!hasSavingsThisMonth && (
        <Spacing marginTop={2}>
          <DealLanes />
        </Spacing>
      )}
    </Loading>
  )
}

export default TabContent
